import { SVG_FACEBOOK } from '../components/theme/icons/social/facebook'
import { SVG_TWITTER } from '../components/theme/icons/social/twitter'
import { SVG_YOUTUBE } from '../components/theme/icons/social/youtube'
import { SVG_LINKEDIN } from '../components/theme/icons/social/linkedin'
import { SVG_INSTAGRAM } from '../components/theme/icons/social/instagram'
import { SVG_BLOG } from '../components/theme/icons/social/blog'

/**
 * URLS
 */
// Siempre mismo origen: en local el dev server hace de proxy de /api hacia INT (ver config-overrides.js),
// y la aplicación desplegada comparte host con el BFF. No apuntar esto a un host de backend:
// el BFF no devuelve cabeceras CORS, así que el navegador bloquea cualquier llamada cross-origin.
export const BACKEND_LOGIN_URL = window.location.origin

/**
 * LOCAL STORAGE ITEMS
 */
export const LOCAL_STORAGE_ITEMS__LOCALE = 'locale'

/**
 * COOKIE DE IDIOMA COMPARTIDA
 * El idioma se comparte entre los frontales de la marca (portal de empresa, OAuth y mi usuario),
 * que viven en subdominios distintos y por tanto no comparten localStorage. Una cookie fijada en el
 * dominio registrable de la marca sí es visible desde todos ellos.
 */
export const LOCALE_COOKIE_NAME = 'locale'
export const LOCALE_COOKIE_MAX_AGE_SECONDS = 31536000
export const COOKIE_PATH = '/'
export const COOKIE_SAME_SITE_LAX = 'Lax'
export const COOKIE_SECURE = 'Secure'
export const COOKIE_PAIR_SEPARATOR = '; '
export const COOKIE_DOMAIN_LABELS = 2
export const PROTOCOL_HTTPS = 'https:'

/**
 * IDIOMA EN LA URL
 * El enlace de reseteo de contraseña que el backend envía por email arrastra en este parámetro el
 * idioma con el que se solicitó la recuperación, para poder conservarlo al entrar desde el correo.
 */
export const LOCALE_QUERY_PARAM = 'idioma'

/**
 * IMÁGENES
 */
export const DATA_URI_PREFIX = 'data:'
export const SVG_DATA_URI_PREFIX = 'data:image/svg+xml,'

/**
 * MARCAS
 */
export const EUSKALTEL = 'Euskaltel'
export const TELECABLE = 'Telecable'
export const MUNDO_R = 'Mundo-R'

export const BRAND_NAMES = [EUSKALTEL, TELECABLE, MUNDO_R]

export const BRAND_ABBREVIATON_MUNDO_R = 'R'
export const BRAND_ABBREVIATON_TELECABLE = 'T'
export const BRAND_ABBREVIATON_EUSKALTEL = 'K'

/**
 * TAMAÑOS
 */
export const BUTTON_SIZE_SMALL = 'small'
export const BUTTON_SIZE_MEDIUM = 'medium'
export const BUTTON_SIZE_LARGE = 'large'

/**
 * CÓDIGOS DE ERROR
 */
export const ERROR_CODE_GENERIC_STRING = 'genericError'
export const ERROR_CODE_GENERIC_OAUTH_STRING = 'genericOAuthError'
export const ERROR_CODE_DEFAULT_STATE = '-1'

/**
 * BREAKPOINTS
 */
export const BREAKPOINT_MD = 960

/**
 * IDIOMAS
 */
export const LOCALE_ES = 'es'
export const LOCALE_EU = 'eu'
export const LOCALE_GL = 'gl'

/**
 * DIRECCIONES
 */
export const FACEBOOK = 'facebook'
export const TWITTER = 'twitter'
export const YOUTUBE = 'youtube'
export const LINKEDIN = 'linkedin'
export const INSTAGRAM = 'instagram'
export const BLOG = 'blog'

export const BRANDS_ABBREVIATIONS = {
  [EUSKALTEL]: BRAND_ABBREVIATON_EUSKALTEL,
  [MUNDO_R]: BRAND_ABBREVIATON_MUNDO_R,
  [TELECABLE]: BRAND_ABBREVIATON_TELECABLE,
}

export const socialNetworkIcons = {
  [FACEBOOK]: SVG_FACEBOOK,
  [TWITTER]: SVG_TWITTER,
  [YOUTUBE]: SVG_YOUTUBE,
  [LINKEDIN]: SVG_LINKEDIN,
  [INSTAGRAM]: SVG_INSTAGRAM,
  [BLOG]: SVG_BLOG,
}

/**
 * JS
 */
export const EVENT_BACKDROP_CLICK = 'backdropClick'
export const EVENT_ESCAPE_KEY_DOWN = 'escapeKeyDown'

/**
 * TIMEOUT
 */
export const ERROR_MESSAGE_TIMEOUT = 5000

/**
 * CONTRASEÑAS
 * Criterio alineado con el registro de producción (apce_frontend): entre 12 y 15 caracteres y
 * elementos de al menos 3 de los 4 grupos (mayúsculas, minúsculas, números o caracteres especiales).
 */
export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_MAX_LENGTH = 15
export const PASSWORD_MIN_GROUPS = 3
export const PASSWORD_SPECIAL_CHARS = "$ & ( ) + ' - . ; = ? _"

/**
 * JWT
 */
export const JWT_EXP_TO_MS = 1000
